'use client';

import { useEffect } from 'react';

import { showTooltip } from '@/helpers/tooltip';
import { useGetCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';
import { hasUnseenBonus } from '../lib/isUnseenBonus';
import { BonusReceivedTooltip } from '../ui/BonusReceivedTooltip';
import { useActiveBonusesTabStore } from './activeBonusesTabStore';

export const useNotifyBonusesOnReturn = (): void => {
  const useCommonStore = useGetCommonStore();
  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const fetchBonuses = useCommonStore.use.fetchBonuses();
  const fetchFreespins = useCommonStore.use.fetchFreespins();

  useEffect(() => {
    if (!isAuthenticated) return;

    let hiddenAt: number | null = null;

    const handleVisibilityChange = async () => {
      if (document.visibilityState === 'hidden') {
        hiddenAt = Date.now();
        return;
      }

      if (hiddenAt == null) return;
      const awaySince = hiddenAt;
      hiddenAt = null;

      if (useActiveBonusesTabStore.getState().isOpen) return;

      await Promise.all([fetchBonuses(), fetchFreespins()]);

      const { bonuses, freespins } = useCommonStore.getState();

      if (
        hasUnseenBonus(bonuses, awaySince) ||
        hasUnseenBonus(freespins, awaySince)
      ) {
        showTooltip({
          type: TooltipTypes.SUCCESS,
          body: <BonusReceivedTooltip />,
          pauseOnHover: true,
        });
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated, fetchBonuses, fetchFreespins, useCommonStore]);
};
